<template>
  <!--关于我们页面-->
  <tk-container
    :status="status"
  >
    <!--头部-->
    <tkui-header center slot="header">
      <div slot="left-menu" @click="$back()">
        <tkui-button class="icon">
          <tk-icon size="16">return</tk-icon>
        </tkui-button>
      </div>
      评价
      <!--提交按钮-->
      <action-button
        slot="right"
        class="m-x-15"
        :btn-text="'提交'" :bg-color="'#D84342'"
        :bd-color="'#D84342'" :text-color="'#fff'"
        :min-width="54" :height="26" is-raised is-rounded
        :disabled="applyDisabled"
        @click.native="submitEvaluated"
      ></action-button>
    </tkui-header>
    <!--评价等级-->
    <tk-card
      :height="50" :width="100"
      is-middle
      class="cancel-radius"
    >
      <tk-flex between class="full-width">
        <div>产品评价</div>
        <van-rate v-model="orderAltered" size="17" allow-half color="#deaf48" void-icon="star" void-color="#c2bfc2" />
        <div class="caption font-16 tk-grid-2 text-center">{{orderAltered | alteredText}}</div>
      </tk-flex>
      <tk-flex between class="full-width m-t-15">
        <div>服务评价</div>
        <van-rate v-model="serviceAltered" size="17" allow-half color="#deaf48" void-icon="star" void-color="#c2bfc2" />
        <div class="caption font-16 tk-grid-2 text-center">{{serviceAltered | alteredText}}</div>
      </tk-flex>
      <tk-flex between class="full-width m-t-15">
        <div>物流评价</div>
        <van-rate v-model="logisticsAltered" size="17" allow-half color="#deaf48" void-icon="star" void-color="#c2bfc2" />
        <div class="caption font-16 tk-grid-2 text-center">{{logisticsAltered | alteredText}}</div>
      </tk-flex>
    </tk-card>
    <!--评价内容-->
    <card :height="100" :width="100" class="m-t-10 cancel-radius">
      <textarea name="hehe" id="text-input" cols="80" rows="9" v-model="commentContent"
                class="text-input m-t-10"
                placeholder="感谢您对我们的产品、配送和服务进行评价，您的评价将有助于我们做的更好。"
      ></textarea>
      <tk-flex middle v-if="isCountyAccount" right class="text-tips">评价可得 <span class="primary m-t-2">10</span> 个欢乐豆</tk-flex>
      <three-image-post class="m-t-12 p-0" @postImage="receiveParams"></three-image-post>
    </card>
  </tk-container>
</template>

<script>
import threeImagePost from '@/components/threeImagePost'
import { Rate } from 'vant'
export default {
  components: {
    threeImagePost,
    [Rate.name]: Rate
  },
  data () {
    return {
      status: false, // 页面状态
      applyDisabled: false, // 提交按钮状态
      orderAltered: 5, // 订单评价
      serviceAltered: 5, // 服务评价
      logisticsAltered: 5, // 物流评价
      commentContent: '', // 评价内容
      pictureCombination: [] // 评论晒图
    }
  },
  filters: {
    alteredText (value) {
      if (value <= 1) {
        return '很差'
      }
      if (value <= 2 && value > 1) {
        return '差'
      }
      if (value <= 3 && value > 2) {
        return '一般'
      }
      if (value <= 4 && value > 3) {
        return '满意'
      }
      if (value <= 5 && value > 4) {
        return '超赞'
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  computed: {
    // 县代账号购买商品送欢乐豆
    orderHappyBeanSum () {
      if (!this.userInfo.accountCategory) { return 0 }
      if (this.userInfo.accountCategory !== 'countyAccount') { return 0 }
      if (this.levelName === 'registeredMember' || this.levelName === 'bronzeMember') { return 50 }
      if (this.levelName === 'silverMembers') { return 100 }
      if (this.levelName === 'goldMembers') { return 150 }
      if (this.levelName === 'diamondMembers') { return 200 }
      return 0
    },
    // 用户当前成长值
    userGrowth () {
      if (!this.userInfo) { return 0 }
      return this.userInfo.growthValue ? this.userInfo.growthValue : 0
    }
  },
  mounted () {
    this.setStatusBar('dark')
  },
  methods: {
    /**
     * @Description: 接收图片数组
     * @author xiaozan
     * @date 2020/5/3
     */
    receiveParams (arr) {
      this.pictureCombination = arr
    },
    /**
     * @Description: 县代用户增加成长值
     * @author xiaozan
     * @date 2020/5/6
     */
    async updateUserLevel () {
      // if (this.levelName === 'registeredMember') { return 20000 }
      // if (this.levelName === 'bronzeMember') { return 50000 }
      // if (this.levelName === 'silverMembers') { return 100000 }
      // if (this.levelName === 'goldMembers') { return 200000 }
      // if (this.levelName === 'diamondMembers') { return 9999999 }
      // 订单满100送欢乐豆
      let order = await this.$tkParse.getData(`/classes/order/${this.$route.query.id}`)
      let orderAmount = Math.floor(order.orderAmount)
      let newGrowth = this.userGrowth + orderAmount
      let levelName = ''
      if (!this.levelName) { levelName = 'registeredMember' }
      if (newGrowth <= 20000) { levelName = 'registeredMember' }
      if (newGrowth > 20000 && newGrowth <= 50000) { levelName = 'bronzeMember' }
      if (newGrowth > 50000 && newGrowth <= 100000) { levelName = 'silverMembers' }
      if (newGrowth > 100000 && newGrowth <= 200000) { levelName = 'goldMembers' }
      if (newGrowth > 200000 && newGrowth <= 9999999) { levelName = 'diamondMembers' }
      await this.$store.dispatch('updateUserMsg', {
        membershipLevel: levelName,
        growthValue: newGrowth
      })
    },
    /**
     * @Description: 提交评价
     * @author xiaozan
     * @date 2020/5/4
     */
    async submitEvaluated () {
      if (!this.commentContent) { return this.$tkGlobal.toast.add('评论内容不能为空') }
      let sum = await this.statisticsNum('orderEvaluation',
        { order: this.$route.query.id, buyUser: this.userInfo.objectId })
      if (sum > 0) {
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('请勿重复提交')
      }
      this.status = 'waiting'
      this.applyDisabled = true
      let obj = {
        order: this.$route.query.id,
        pictureCombination: this.pictureCombination,
        commentContent: this.commentContent,
        orderAltered: this.orderAltered,
        serviceAltered: this.serviceAltered,
        logisticsAltered: this.logisticsAltered,
        buyUser: {
          objectId: this.userInfo.objectId,
          __type: 'Pointer',
          className: '_User'
        },
        orderHappyBeanSum: this.orderHappyBeanSum
      }
      // 发送评价
      await this.$cloudAjax.post('/orderActions/$evaluated', obj).catch(e => {
        this.status = false
        this.applyDisabled = false
        throw this.$tkGlobal.toast.add(e.data ? e.data : '评价失败')
      })
      // 县代用户增加成长值
      if (this.isCountyAccount) {
        // 如果为县代用户加成长值
        await this.updateUserLevel()
      }
      let orderDetail = await this.$tkParse.getData(`/classes/order/${this.$route.query.id}`)
      this.$setFlash('orderEdit', { id: orderDetail.objectId, status: orderDetail.status })
      this.$store.commit('setOrderMiddleValue', { id: orderDetail.objectId, status: 'completed', type: 'myOrder' })
      await this.$tkHelper.sleep(500)
      this.$tkGlobal.toast.add('提交评价成功')
      this.$back()
      this.status = false
      this.applyDisabled = false
    }
  }
}
</script>

<style scoped lang="scss">
  /*card去除圆角*/
  .cancel-radius  {
    border-radius: 0 !important;
  }
  /*输入框样式*/
  .text-input {
    height: 100%;
    width: 100%;
    min-width: 0;
  }
  .text-input::placeholder {
    font-size: 14px;
    color: rgba(191, 191, 191, 1);
  }
  .text-tips {
    font-size: 14px;
    color: rgba(191, 191, 191, 1);
  }
  .font-14 {
    font-size: 14px !important;
  }
  .font-16 {
    font-size: 16px !important;
  }
</style>
